import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import EmptyResults from '../EmptyResults';

import { TopicAnalysisStatus } from '../../enum';
import TopicAnalysis from './TopicAnalysis';
import TopicReducer from './TopicAnalysis/TopicReducer';
import SentimentAnalysis from './SentimentAnalysis';

function BasicQuestionResults(props) {
  const [topicAnalysis, dispatchTopicAnalysis] = useReducer(TopicReducer, null);
  const { question, hasResponses, engagementSummary, createdAt } = props;
  const { data } = question;
  const isEmpty = data?.responseCount === 0 || data?.responses?.length === 0;

  useEffect(() => {
    dispatchTopicAnalysis({
      type: 'load',
      payload: question.data,
      engagementSummary,
      createdAt,
      classifications: question.classifications,
    });
  }, []);

  function renderTopKeywords() {
    const columnArray = [
      { Header: '#', accessor: 'position', width: false },
      { Header: 'Word/phrase', accessor: 'word', width: false },
      { Header: 'Responses', accessor: 'ndoc', width: false },
      { Header: 'Mentions', accessor: 'nentry', width: false },
    ];
    const tableData = data.stats.map((stat, index) => ({
      ...stat,
      position: index + 1,
    }));

    return (
      <div className="engage-results-engagement-screen__chart-content__stats">
        <h4 className="engage-results-engagement-screen__chart-content__subtitle">
          <b>Top keywords</b>
        </h4>
        <ZCDTable columnArray={columnArray} tableData={tableData} maxItemsLimit={10} />
      </div>
    );
  }

  if (isEmpty) return <EmptyResults hasResponses={hasResponses} />;

  //
  const bShowTopKeywords = !(
    topicAnalysis?.topicSummary.status === TopicAnalysisStatus.SUCCESS &&
    topicAnalysis?.topicSummary.topics &&
    topicAnalysis?.topicSummary.topics.length > 0
  );
  const bShowSentimentAnlysis =
    !!question?.data?.sentimentAnalysis &&
    Object.keys(question?.data?.sentimentAnalysis).length > 0;

  return (
    <>
      {bShowSentimentAnlysis && (
        <SentimentAnalysis sentimentAnalysis={question.data.sentimentAnalysis} isReportBuilder />
      )}
      {topicAnalysis?.topicSummary && (
        <TopicAnalysis topicState={topicAnalysis} dispatchTopicAnalysis={dispatchTopicAnalysis} />
      )}
      {topicAnalysis?.topicSummary && bShowTopKeywords && <hr />}
      {bShowTopKeywords && (
        <div className="engage-results-engagement-screen__chart-content">{renderTopKeywords()}</div>
      )}
    </>
  );
}

BasicQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    chartType: PropTypes.string,
    showDataTable: PropTypes.bool,
    data: PropTypes.shape({
      responses: PropTypes.arrayOf(PropTypes.string),
      responseCount: PropTypes.number,
      sentimentAnalysis: PropTypes.shape({}),
      stats: PropTypes.arrayOf(
        PropTypes.shape({
          word: PropTypes.string.isRequired,
          ndoc: PropTypes.number.isRequired,
          nentry: PropTypes.number.isRequired,
        })
      ).isRequired,
    }),
    classifications: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
  engagementSummary: PropTypes.shape({
    endTime: PropTypes.string,
  }).isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default BasicQuestionResults;
